import { v4 } from '@leverege/base62-util';
export default {
  install(molten) {
    molten.addPlugin('ItemCreateHook', {
      id: 'recovr.company.contract.companyContractItemCreate',
      matches: {
        objectType: 'companyContract'
      },
      hook: async deviceData => {
        const {
          data
        } = deviceData;
        let contractId = v4().slice(0, 5);
        contractId = contractId.toUpperCase();
        const newDeviceData = {
          data: [...data, {
            path: 'contractId',
            value: contractId
          }]
        };
        return newDeviceData;
      }
    });
  }
};